<div class="container">
    <div class="d-flex align-items-center m-1 justify-content-between">
        <div class="w-50">
            <span *ngIf="surveyType === '14day'" i18n="@@covid.form.reschedule.date">Datum in ura klica, ob naročanju na novo:</span>
            <span *ngIf="surveyType === '1day'" i18n="@@covid.form.before.date">Datum in ura klica dan pred preiskavo:</span>
            <span *ngIf="surveyType === '0day' || surveyType === 'new'" i18n="@@covid.form.term.date">Datum in ura termina:</span>
        </div>
        <div>
            <!-- datum in ura -->
            <div class="form-inline">
                <span class="m-list-search__result-item-text">
                    <input
                        [(ngModel)]="inputDate"
                        [options]="calendarOptions"
                        [disabled]="readOnly"
                        (selected)="setDate($event, 'timeOfTerm')"
                        type="text"
                        daterangepicker
                        name="{{ surveyType }}Date"
                        style="width: 110px"
                        class="form-control m-input"
                        [ngClass]="{ 'pl-0': readOnly }"
                    />
                </span>

                <span class="m-list-search__result-item-text">
                    <input
                        [(ngModel)]="inputHours"
                        [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                        [disabled]="readOnly"
                        (change)="setHour($event)"
                        type="text"
                        ngbAutofocus
                        placeholder="hh:mm"
                        name="{{ surveyType }}Hour"
                        style="width: 70px"
                        class="form-control m-input ml-1"
                        [ngClass]="{ 'pl-0': readOnly }"
                    />
                </span>
            </div>
        </div>
    </div>
    <div *ngIf="surveyType === '0day' || surveyType === 'new'" class="d-flex align-items-center justify-content-between m-1">
        <div class="w-50" i18n="@@covid.form.type">Storitev:</div>
        <div>
            <input
                [(ngModel)]="surveyData.form.investigationType"
                [disabled]="readOnly"
                type="text"
                required
                placeholder="(Obvezno)"
                style="width: 185px"
                name="{{ surveyType }}investigationType"
                class="form-control m-input"
                [ngClass]="{ 'pl-0': readOnly }"
            />
        </div>
    </div>
    <div class="d-flex align-items-center m-1 mt-3">
        <span *ngIf="surveyType === '14day'" style="font-weight: bold">Znaki in simptomi akutne okužbe v zadnjih 14 dneh:</span>
        <span *ngIf="surveyType === '1day'" style="font-weight: bold">Epidemiološki znaki ARI dan pred preiskavo</span>
        <span *ngIf="surveyType === '0day'" style="font-weight: bold">Klinični znaki ARI na dan preiskave</span>
        <span *ngIf="surveyType === 'new'" style="font-weight: bold">Preverjanje zdravstvenega stanja</span>
    </div>
    <div *ngIf="surveyData.form.tt != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Imate povišano telesno temperaturo (nad 37,5°C)?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.tt" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}tt" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.tt" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}tt" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.tt != undefined" />
    <div *ngIf="surveyData.form.cold != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Ste prehlajeni?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.cold" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}cold" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.cold" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}cold" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.cold != undefined" />
    <div *ngIf="surveyData.form.cough != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Kašljate?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.cough" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}cough" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.cough" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}cough" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.cough != undefined" />
    <div *ngIf="surveyData.form.throat != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Vas boli v grlu, žrelu?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.throat" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}throat" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.throat" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}throat" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.throat != undefined" />
    <div *ngIf="surveyData.form.taste != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Imate spremenjen okus ali vonj?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.taste" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}taste" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.taste" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}taste" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.taste != undefined" />
    <div *ngIf="surveyData.form.heavyBreathing != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Imate občutek težkega dihanja ali stiskanja v prsnem košu?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input
                    [(ngModel)]="surveyData.form.heavyBreathing"
                    [value]="true"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}heavyBreathing"
                />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.heavyBreathing"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}heavyBreathing"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.heavyBreathing != undefined" />
    <div *ngIf="surveyData.form.muscleAche != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Imate bolečine v mišicah?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.muscleAche" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}muscleAche" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.muscleAche"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}muscleAche"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.muscleAche != undefined" />
    <div *ngIf="surveyData.form.diarrhea != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">Imate prebavne težave (drisko ali bruhanje)?</div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.diarrhea" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}diarrhea" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.diarrhea" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}diarrhea" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.diarrhea != undefined" />
    <div *ngIf="surveyData.form.family != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Ima kdo drug doma ali v službi takšne težave?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input [(ngModel)]="surveyData.form.family" [value]="true" [disabled]="readOnly" type="radio" name="{{ surveyType }}family" />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input [(ngModel)]="surveyData.form.family" [value]="false" [disabled]="readOnly" type="radio" name="{{ surveyType }}family" />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.family != undefined" />
    <div *ngIf="surveyData.form.feelingSick != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Se slabo počutite?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input
                    [(ngModel)]="surveyData.form.feelingSick"
                    [value]="true"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}feelingSick"
                />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.feelingSick"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}feelingSick"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.feelingSick != undefined" />

    <div *ngIf="surveyData.form.conjunctivitis != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Imate konjuktivitis?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input
                    [(ngModel)]="surveyData.form.conjunctivitis"
                    [value]="true"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}conjunctivitis"
                />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.conjunctivitis"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}conjunctivitis"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <div *ngIf="surveyData.form.positiveTest != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Ste imeli pozitiven izvid testa na okužbo z virusom SARS-CoV-2 oziroma na bolezen COVID-19?</span>
        </div>
        <div class="d-flex ml-1">
            <label class="m-radio m-radio--accent">
                <input
                    [(ngModel)]="surveyData.form.positiveTest"
                    [value]="true"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}positiveTest"
                />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.positiveTest"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}positiveTest"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.positiveTest != undefined" />
    <div *ngIf="surveyData.form.contactWithPositive != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Ste bili v stiku z okuženo osebo (oboleli svojci, sostanovalci ali sodelavci)?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input
                    [(ngModel)]="surveyData.form.contactWithPositive"
                    [value]="true"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}contactWithPositive"
                />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.contactWithPositive"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}contactWithPositive"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <hr *ngIf="surveyData.form.contactWithPositive != undefined" />
    <div *ngIf="surveyData.form.contactWithPotentialPositive != undefined" class="d-flex align-items-center m-1">
        <div class="w-100">
            <span>Ste bili v stiku s potencialno okuženo osebo (oboleli svojci, sostanovalci ali sodelavci)?</span>
        </div>
        <div class="d-flex">
            <label class="m-radio m-radio--accent">
                <input
                    [(ngModel)]="surveyData.form.contactWithPotentialPositive"
                    [value]="true"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}contactWithPotentialPositive"
                />
                Da
                <span></span>
            </label>
            <label class="m-radio m-radio--brand ml-3">
                <input
                    [(ngModel)]="surveyData.form.contactWithPotentialPositive"
                    [value]="false"
                    [disabled]="readOnly"
                    type="radio"
                    name="{{ surveyType }}contactWithPotentialPositive"
                />
                Ne
                <span></span>
            </label>
        </div>
    </div>
    <ng-container *ngIf="surveyType === 'new'">
        <hr />
        <div class="d-flex align-items-center m-1">
            <div class="w-100">
                <span>Izpolnjujem PCT pogoj z naslednjim dokazilom:</span>
            </div>
        </div>
        <div class="d-flex align-items-center m-1">
            <div class="d-flex align-items-center">
                <b>Dokazilo:</b>
                <ng-select
                    [(ngModel)]="surveyData.form.pctType"
                    [disabled]="readOnly"
                    [clearable]="false"
                    [items]="['Cepljen/a', 'Testiran', 'Prebolevnik']"
                    style="width: 120px"
                    class="ml-2"
                ></ng-select>
            </div>
        </div>
        <div class="d-flex m-1 align-items-center justify-content-between">
            <ng-container [ngSwitch]="surveyData?.form?.pctType">
                <span *ngSwitchCase="'Prebolevnik'">Datum veljavnosti, ki je naveden na potrdilu:</span>
                <span *ngSwitchCase="'Cepljen/a'">Datum zadnjega odmerka:</span>
                <span *ngSwitchCase="'Testiran'">Datum opravljenega hitrega testa:</span>
            </ng-container>
            <input
                [(ngModel)]="pctDate"
                [options]="calendarOptions"
                [disabled]="readOnly"
                (selected)="setDate($event, 'timeOfPct')"
                type="text"
                daterangepicker
                style="width: 110px"
                class="form-control m-input ml-2"
                [ngClass]="{ 'pl-0': readOnly }"
            />
        </div>
        <div *ngIf="surveyData?.form?.pctType === 'Testiran'" class="d-flex m-1 align-items-center justify-content-between">
            <span>Rezultat testa:</span>
            <ng-select
                [(ngModel)]="surveyData.form.pctResult"
                [clearable]="false"
                [disabled]="readOnly"
                [items]="[true, false]"
                style="width: 110px"
                class="ml-2"
            >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    <span *ngIf="item">Pozitiven</span>
                    <span *ngIf="!item">Negativen</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    <span *ngIf="item">Pozitiven</span>
                    <span *ngIf="!item">Negativen</span>
                </ng-template>
            </ng-select>
        </div>
    </ng-container>
    <div *ngIf="readOnly" class="d-flex align-items-center m-1 mt-3">
        <span i18n="@@covid.form.signedBy">Podpisal(a):</span>
        <span style="font-weight: bold; margin-left: 3px">{{ surveyData.signedBy }}</span>
    </div>
</div>
